import styled from "styled-components";
import { COLORS } from "./colors";



// LoadingIcon
interface LoadingIconProps {
  size: string;
  color: string;
}
export const LoadingIcon = styled.div<LoadingIconProps>`
    display: inline-block;
    width: ${(props) => props.size};
    height: ${(props) => props.size};

  @keyframes lds-dual-ring {
    0% {
    transform: rotate(0deg);
    }
    100% {
    transform: rotate(360deg);
    }
  }

  ::after {
    content: " ";
    display: block;
    width: ${(props) => props.size};
    height: ${(props) => props.size};
    border-radius: 50%;
    border: 3px solid ${(props) => props.color};
    border-color: ${(props) => props.color} ${COLORS.transparent_color1} ${(props) => props.color} ${COLORS.transparent_color1};
    animation: lds-dual-ring 1.2s linear infinite;
  }
`;